// extracted by mini-css-extract-plugin
export default {"table":"TableComponent_table__thh-4","tableSub":"TableComponent_tableSub__s0Az5","table2":"TableComponent_table2__Z8ioC"};